import {Helmet} from "react-helmet";
import {
    Box,
    Button,
    Container,
    Divider,
    Grid,
    styled,
    Tab,
    tabClasses,
    Tabs,
    Typography,
    useMediaQuery
} from "@mui/material";
import {useState} from "react";
import {
    AndroidRounded,
    BrowserUpdatedRounded,
    DesktopMacRounded,
    DesktopWindowsRounded,
    TabletMacRounded
} from "@mui/icons-material";
import TabPanel from "../../../components/common/tabPanel";

export default function Download() {

    const [tabIndex, setTabIndex] = useState(0);
    const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));

    return (
        <>
            <Helmet>
                <title>دانلود - میلفا</title>
            </Helmet>
            <Container sx={{ mt: 3, mb: 7 }}>
                <Typography variant="h1" fontSize={{ xs: "1.1rem", lg: "1.2rem" }} fontWeight={800}>دانلود اپ میلفا</Typography>
                <Typography mt={1}>با توجه به سیستم عامل دستگاه خود اپ مورد نظر را دانلود کنید</Typography>
                <Box mt={3} sx={{ p: {xs: 2, lg: 2.5}, display: "flex", flexDirection: {xs: "column", lg: "row"}, minHeight: {xs: "50vw", lg: "25vw"}, background: theme => theme.palette.grey.main, borderRadius: 2 }}>
                    <StyledTabs value={tabIndex} onChange={(e ,newValue) => setTabIndex(newValue)} orientation={!isMobile ? "vertical" : "horizontal"}>
                        <Tab label="Android" icon={<AndroidRounded fontSize="small"/>} iconPosition="start"/>
                        <Tab label="iOS" icon={<TabletMacRounded fontSize="small"/>} iconPosition="start"/>
                        <Tab label="macOS" icon={<DesktopMacRounded fontSize="small"/>} iconPosition="start"/>
                        <Tab label="Windows" icon={<DesktopWindowsRounded fontSize="small"/>} iconPosition="start"/>
                    </StyledTabs>
                    <Box ml={{ xs: 0, lg: 5 }} mt={{ xs: 2, lg: 0 }} flex={1}>
                        <TabPanel value={tabIndex} index={0}>
                            <Typography fontSize={{ xs: "1.1rem" }} fontWeight={600} textAlign={{ xs: "center", lg: "initial" }}>دانلود اپلیکیشن اندروید</Typography>
                            <Grid mt={1} container spacing={2}>
                                <Grid item xs={12} container >
                                    <Grid item xs={12} lg={3}>
                                        <a href="#" target="_blank">
                                            <Box component="img" src="/assets/image/logo/mobile-coffe-bazzar.svg" width={1} height={64} sx={{ objectFit: "contain", objectPosition: {xs: "center", lg: "left"} }}/>
                                        </a>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <a href="#" target="_blank">
                                            <Box component="img" src="/assets/image/logo/myket-dark.svg" width={1} height={64} sx={{ objectFit: "contain", objectPosition: {xs: "center", lg: "left"} }}/>
                                        </a>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <a href="/static/apps/mailfa-drive.apk" target="_blank">
                                            <Button variant="contained" fullWidth startIcon={<BrowserUpdatedRounded/>} disableElevation sx={{ borderRadius: 2, py: 1.7 }}>دانلود مستقیم</Button>
                                        </a>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} container>
                                    <Grid item xs={12} lg={12}>
                                        <Divider/>
                                        <Typography mt={2} fontSize=".975rem" fontWeight={500}>نصب وب اپلیکشن (PWA)</Typography>
                                        <Typography mt={.5} fontSize=".925rem">بروی دکمه منوی (…) در پایین صفحه مرورگر کلیک کنید و گزینه های install و Add to screen را از بین گزینه های موجود انتخاب نمایید ودر صفحه جدیدی که ظاهر میشود گزینه Add را انتخاب نمایید تا اپلیکیشن مانند سایر برنامه ها روی گوشی شما نصب شود</Typography>
                                        <Box mt={1.5} component="img" src="/assets/image/logo/pwa-android.jpg" width={1} height={350} sx={{ objectFit: "contain" }}/>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </TabPanel>
                        <TabPanel value={tabIndex} index={1}>
                            <Typography fontSize={{ xs: "1.1rem" }} fontWeight={600} textAlign={{ xs: "center", lg: "initial" }}>دانلود اپلیکیشن iOS</Typography>
                            <Grid mt={1} container spacing={2}>
                                <Grid item xs={12} container spacing={2}>
                                    <Grid item xs={12} lg={3}>
                                        <a href="#" target="_blank">
                                            <Box component="img" src="/assets/image/logo/sib-app-dark.svg" width={1} height={64} sx={{ objectFit: "contain", objectPosition: {xs: "center", lg: "left"} }}/>
                                        </a>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <a href="#" target="_blank">
                                            <Box component="img" src="/assets/image/logo/sib-irani.png" width={1} height={64} sx={{ objectFit: "contain", objectPosition: {xs: "center", lg: "left"} }}/>
                                        </a>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <a href="#" target="_blank">
                                            <Box component="img" src="/assets/image/logo/sibche.png" width={1} height={64} sx={{ objectFit: "contain", objectPosition: {xs: "center", lg: "left"} }}/>
                                        </a>
                                    </Grid>
                                    {/*<Grid item xs={12} lg={3}>*/}
                                    {/*    <a href="#" target="_blank">*/}
                                    {/*        <Box component="img" src="/assets/image/logo/anardooni.png" width={1} height={64} sx={{ objectFit: "contain", objectPosition: {xs: "center", lg: "left"} }}/>*/}
                                    {/*    </a>*/}
                                    {/*</Grid>*/}
                                    <Grid item xs={12} lg={3}>
                                        <a href="#" target="_blank">
                                            <Box component="img" src="/assets/image/logo/iapps.png" width={1} height={64} sx={{ objectFit: "contain", objectPosition: {xs: "center", lg: "left"} }}/>
                                        </a>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} container>
                                    <Grid item xs={12} lg={12}>
                                        <Divider/>
                                        <Typography mt={2} fontSize=".975rem" fontWeight={500}>نصب وب اپلیکشن (PWA)</Typography>
                                        <Typography mt={.5} fontSize=".925rem">ابتدا گزینه Share را از نوار پایین صفحه مرورگر در موبایل خود انتخاب کنید، سپس Add to Home Screen را بزنید و در آخر گزینه Add را انتخاب کنید.  به همین سادگی آیکون میلفا به صفحه اصلی موبایل آیفون شما اضافه می‌شود.</Typography>
                                        <Box mt={1.5} component="img" src="/assets/image/logo/pwa.jpg" width={1} height={350} sx={{ objectFit: "contain" }}/>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </TabPanel>
                        <TabPanel value={tabIndex} index={2}>
                            <Typography fontSize={{ xs: "1.1rem" }} fontWeight={600} textAlign={{ xs: "center", lg: "initial" }}>دانلود اپلیکیشن macOS</Typography>
                            <Grid mt={1} container spacing={2}>
                                <Grid item xs={12} container >
                                    <Grid item xs={12} lg={4}>
                                        <a href="#" target="_blank">
                                            <Button variant="contained" fullWidth startIcon={<BrowserUpdatedRounded/>} disableElevation sx={{ borderRadius: 2, py: 1.7 }}>دانلود نسخه macOS</Button>
                                        </a>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </TabPanel>
                        <TabPanel value={tabIndex} index={3}>
                            <Typography fontSize={{ xs: "1.1rem" }} fontWeight={600} textAlign={{ xs: "center", lg: "initial" }}>دانلود اپلیکیشن Windows</Typography>
                            <Grid mt={1} container spacing={2}>
                                <Grid item xs={12} container >
                                    <Grid item xs={12} lg={4}>
                                        <a href="#" target="_blank">
                                            <Button variant="contained" fullWidth startIcon={<BrowserUpdatedRounded/>} disableElevation sx={{ borderRadius: 2, py: 1.7 }}>دانلود نسخه  Windows x64 Bit</Button>
                                        </a>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} container >
                                    <Grid item xs={12} lg={4}>
                                        <a href="#" target="_blank">
                                            <Button variant="contained" fullWidth startIcon={<BrowserUpdatedRounded/>} disableElevation sx={{borderRadius: 2, py: 1.7}}>دانلود نسخه Windows x32 Bit</Button>
                                        </a>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </TabPanel>
                    </Box>
                </Box>
            </Container>
        </>
    )
}

const StyledTabs = styled(Tabs)(({theme}) => ({
    [`& .${tabClasses.root}`]: {
        minWidth: "auto",
        minHeight: "auto",
        padding: 12
    },
    [theme.breakpoints.up('lg')]: {
        width: "10rem",
    }
}));
